import React, { Component } from 'react';
import InwardingApiHandlerTest from './../../InwardingApiHandlerTest.js';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
import ImageViewer from './../../../../commons/ImageViewer';
import doc_done from './../../../../assets/img/doc_done.png';
import close from './../../../../assets/img/close.png';
import Dialog from '@material-ui/core/Dialog';
import ErrorBox from './../../../../commons/ErrorBox';
import CONF from '../../../../config/config.js';
import InputFloating from './../../../../commons/InputFloating.js';
import GenericFileUploader from '../../../../commons/GenericFileUploader.js';
import LocalPDFViewer from '../../../../commons/LocalPDFViewer.js';
import apiHandler from '../../../../utilities/apiHandler.js';
import jsPDF from 'jspdf';

const numfor = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0
});

var invoiceTypes = ["Tax Invoice", "Bill Of Supply", "Duplicate Invoice", "Credit Bill", "Delivery Slip", "Lorry Receipt", "Extra Copy", "Order Form", "Return Challan", "Others"];

const INVOICE_DATE_ERROR = 'Invoice Date can not be more than 7 Days older from today.';

export default class InvoiceInwardTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pods: [],
            enableNewPo: true,
            podNumber: '',
            selectedInvoiceType: 'Tax Invoice',
            uploadResponse: null,
            invoiceType: null,
            vendorInvoiceNo: '',
            invoiceDate: '',
            invoiceAmount: '',
            noOfUniqueItems: '',
            docCreated: false,
            docCreatedBox: false,
            createdInvoiceId: null,
            fileType: '',
			pdfFile: null,
			capturedImages: [],
			generatingPdf: false,
			generatedPdfBlob: null,
			generatedPdfPreview: null,
			zoomedImage: null,
        }
    }

    getPODDetails = () => {
        const { podNumber } = this.state;
        let pod = podNumber.toUpperCase();
        InwardingApiHandlerTest.getPODDetails(pod)
            .then((resp) => {
                this.setState({ enableNewPo: false });
                this.setState(prevState => ({
                    pods: [...prevState.pods, resp]
                }))
            }).catch((error) => {
                this.setState({ error: error.error.error });
            }).finally(() => {

            })
    }

	getPreSignedUploadUrl = async (vendorInvoiceNo, invoiceDate, po) => {
		const presignedUrlPayload = {
			vendorId: po.vendorId,
			vendorInvoiceNumber: vendorInvoiceNo,
			documentDate: invoiceDate,
			documentType: 'VENDOR_INVOICE_INWARD_DOC'
		};

		const s3UploadUrl = await InwardingApiHandlerTest.getS3UploadPresignedUrl(presignedUrlPayload);
		return s3UploadUrl;
	}

    createInwardingDocument = async () => {
        const { pods, selectedInvoiceType, vendorInvoiceNo, invoiceDate, invoiceAmount, noOfUniqueItems, pdfBlobFile } = this.state;

		try {
			this.setState({ loading: true });

			const invoiceTimeStamp = new Date(invoiceDate).getTime();

			//Step1: get presigned url from our backend server
			const preSignedUploadUrl = await this.getPreSignedUploadUrl(vendorInvoiceNo, invoiceTimeStamp, pods[0]);

			//Step2: upload the file to the presigned url and get documentchecksum from headers
			const documentS3CheckSum = await apiHandler.uploadFileToS3(preSignedUploadUrl.url, pdfBlobFile);


			//step3: create inwarding doc
			const createInwardingDocPayload = {	
				invoiceDate: invoiceTimeStamp,
				rpoOrderIds: pods.map(p => {
					return p.orderId
				}),
				vendorId: pods.map(p => {
					return p.vendorId
				})[0],
				vendorInvoiceNumber: vendorInvoiceNo,
				numberOfItems: noOfUniqueItems,
				invoiceAmount: invoiceAmount,
				invoiceType: selectedInvoiceType,
				documentS3CheckSum: documentS3CheckSum.replace(/^"|"$/g, ''),
        	};

			const response = await InwardingApiHandlerTest.createInwardingDocument(createInwardingDocPayload);
           	this.setState({ docCreated: true, docCreatedBox: true, createdInvoiceId: response, loading: false });

		} catch (error) {
			console.error(error);
			if(error && error.error){
				this.setState({ error: error.error.error, loading: false });
			}	
		}
    }


    podNumberChanged = (e) => {
        this.setState({ podNumber: e.target.value });
    }

    wantToAddNewPO = () => {
        this.setState({ enableNewPo: true, podNumber: '' });
    }

    handleUploadResponse = (resp, type) => {
        this.setState({ uploadResponse: resp, fileType: type });
    }

    invoiceDetailChanged = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    invoiceTypeSelected = (type) => {
        this.setState({ selectedInvoiceType: type });
    }

    onDeleteClick = () => {
        this.setState({ uploadResponse: null });
    }

    canDocumentCreationHappen = () => {
        const { pods, selectedInvoiceType, uploadResponse, vendorInvoiceNo, invoiceDate, invoiceAmount, noOfUniqueItems } = this.state;
        if (pods.length > 0 && selectedInvoiceType && uploadResponse && vendorInvoiceNo && invoiceDate && invoiceAmount && noOfUniqueItems && !this.invoiceDateValidation()) {
            return true;
        }
        return false;
    }

    removePOD = (index) => {
        var i = this.state.pods;
        i.splice(index, 1);
        if (i.length === 0) {
            this.setState({ enableNewPo: true });
        }
        this.setState({ pods: i, podNumber: '' });
    }

    closeDocCreatedBox = () => {
        this.setState({ docCreatedBox: false });
    }

    goBackPage = () => {
        this.props.history.push({
            pathname: '/Inwarding'
        })
    }

    startInwarding = () => {
        const { createdInvoiceId } = this.state;
        this.props.history.push({
            pathname: '/Inwarding/AddPallet/' + createdInvoiceId
        })
    }

    invoiceDateValidation() {
        if (this.state.invoiceDate) {
            var currentDate = new Date();
            var choosedDate = new Date(this.state.invoiceDate);

            var timeDiff = Math.abs(currentDate.getTime() - choosedDate.getTime());
            var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
            if (diffDays > 7) {
                return true;
            }
        }
        return false;
    }

    closeError = () => { this.setState({ error: null }) }


    showScannedPods = () => {
        const { pods, docCreated } = this.state;
        return (
            pods.map((p, index) => {
                return (
                    <div className="top-twenty" key={index}>
                        <div className="row">
                            <div className="col-xs-8">POD # {index + 1}</div>
                            <div className="col-xs-4 text-right">
                                {(!docCreated) ?
                                    <div onClick={() => { this.removePOD(index) }}><img src={close} style={{ width: '22px', height: '22px', opacity: '0.7' }} alt="x" /></div> : null
                                }
                            </div>
                        </div>
                        <div className="top-ten">
                            <div className="c-b-u">Facility Centre</div>
                            <div className="pod-itm-big">{p.facilityName}</div>
                        </div>
                        <div>
                            <div className="c-b-u">Vendor Name</div>
                            <div className="pod-itm-big">{p.vendorName}</div>
                        </div>
                        <div className="top-ten">
                            <div className="c-b-u">Seller Name</div>
                            <div className="pod-itm-big">{p.sellerName}</div>
                        </div>
                    </div>
                )
            })
        )
    }

	handleFileDrop = (file) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			this.setState({
				pdfFile: reader.result,
				uploadResponse: true,
				fileType: file.type,
				pdfBlobFile: file,
			})
		};
		reader.readAsDataURL(file);
	}

	handleOnFileDelete = () => {
		this.setState({
			pdfFile: 'reader.result',
			uploadResponse: false,
			fileType: '',
			pdfBlobFile: '',
			capturedImages: [],
			generatedPdfBlob: null,
			generatedPdfPreview: null,
		})
	}

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	}

	onCaptureImages = (e) => {
		const files = Array.from(e.target.files || []);
		e.target.value = null;
		if (!files.length) return;

		const readers = files.map((file) => new Promise((resolve) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve({ file, previewUrl: reader.result });
			reader.readAsDataURL(file);
		}));

		Promise.all(readers).then((newImages) => {
			this.setState((prevState) => ({
				capturedImages: [...prevState.capturedImages, ...newImages]
			}));
		});
	}

	removeCapturedImage = (index) => {
		this.setState((prevState) => {
			const capturedImages = [...prevState.capturedImages];
			capturedImages.splice(index, 1);
			return { capturedImages };
		});
	}

	openImageZoom = (previewUrl) => {
		this.setState({ zoomedImage: previewUrl });
	}

	closeImageZoom = () => {
		this.setState({ zoomedImage: null });
	}

	discardGeneratedPdf = () => {
		this.setState({
			capturedImages: [],
			generatedPdfBlob: null,
			generatedPdfPreview: null,
		});
	}

	getImageDimensions = (src) => {
		return new Promise((resolve) => {
			const img = new Image();
			img.onload = () => resolve({ width: img.width, height: img.height });
			img.src = src;
		});
	}

	generatePdfFromImages = async () => {
		const { capturedImages } = this.state;
		if (!capturedImages.length) return;

		this.setState({ generatingPdf: true });
		try {
			const pdf = new jsPDF();
			for (let i = 0; i < capturedImages.length; i++) {
				const image = capturedImages[i];
				const dims = await this.getImageDimensions(image.previewUrl);
				const pageWidth = pdf.internal.pageSize.width;
				const pageHeight = pdf.internal.pageSize.height;
				const ratio = Math.min(pageWidth / dims.width, pageHeight / dims.height);
				const renderWidth = dims.width * ratio;
				const renderHeight = dims.height * ratio;
				const x = (pageWidth - renderWidth) / 2;
				const y = (pageHeight - renderHeight) / 2;
				const format = image.file.type.indexOf('png') !== -1 ? 'PNG' : 'JPEG';

				if (i > 0) pdf.addPage();
				pdf.addImage(image.previewUrl, format, x, y, renderWidth, renderHeight);
			}

			this.setState({
				generatedPdfBlob: pdf.output('blob'),
				generatedPdfPreview: pdf.output('datauristring'),
				generatingPdf: false,
			});
		} catch (e) {
			this.setState({ generatingPdf: false, error: 'Failed to generate PDF from captured images.' });
		}
	}

	confirmGeneratedPdf = () => {
		const { generatedPdfBlob, generatedPdfPreview } = this.state;
		this.setState({
			pdfFile: generatedPdfPreview,
			uploadResponse: true,
			fileType: 'application/pdf',
			pdfBlobFile: generatedPdfBlob,
		});
	}

    showNewPOD = () => {
        const { pods, enableNewPo, podNumber, docCreated } = this.state;
        return (
            <div>
                {(!docCreated) ?
                    <div>
                        {(enableNewPo) ?
                            <div className="top-twenty">
                                <div>POD # {pods.length + 1}</div>
                                <div className="top-twenty">
                                    <div className="row">
                                        <div className="col-xs-10 no-right-padding">
                                            <InputFloating type="text" label="Enter POD Number" value={podNumber} onChange={this.podNumberChanged} />
                                        </div>
                                        <div className="col-xs-2 no-left-padding">
                                            <button className={"btn pod-btn " + (podNumber ? "pod-in" : "pod-dis")} disabled={(podNumber ? false : true)} onClick={this.getPODDetails}><i className="fas fa-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="c-b-u text-right">
                                <div style={{ textDecoration: 'underline' }} onClick={this.wantToAddNewPO}>+Add Another POD</div>
                            </div>
                        }
                    </div> : null
                }
            </div>)
    }

	showCaptureImages = () => {
		const { capturedImages, generatingPdf, zoomedImage } = this.state;
		return (
			<div className="white-box">
				<div className="c-b-u">Capture Images</div>
				<div className="top-twenty">
					<label htmlFor="captureInvoiceImagesInput" className="btn btn-jt-primary" style={{ display: 'inline-block', cursor: 'pointer' }}>
						<i className="fas fa-camera"></i> Capture Image
					</label>
					<input
						id="captureInvoiceImagesInput"
						type="file"
						accept="image/*"
						capture="environment"
						multiple
						style={{ display: 'none' }}
						onChange={this.onCaptureImages}
					/>
				</div>
				{(capturedImages.length > 0) &&
					<div className="row top-twenty">
						{capturedImages.map((image, index) => (
							<div className="col-xs-4 top-ten" key={index} style={{ position: 'relative' }}>
								<img
									src={image.previewUrl}
									alt={'capture-' + index}
									style={{ width: '100%', borderRadius: '4px', cursor: 'zoom-in' }}
									onClick={() => { this.openImageZoom(image.previewUrl) }}
								/>
								<div
									onClick={() => { this.removeCapturedImage(index) }}
									style={{ position: 'absolute', top: '4px', right: '4px', cursor: 'pointer' }}
								>
									<img src={close} alt="remove" style={{ width: '18px', height: '18px' }} />
								</div>
							</div>
						))}
					</div>
				}
				<Dialog open={!!zoomedImage} maxWidth="lg" onClose={this.closeImageZoom}>
					<div className='po-dialog-container'>
						<div className="text-right" onClick={this.closeImageZoom}>
							<img src={close} className='cross-image' alt="x" style={{ cursor: 'pointer' }} />
						</div>
						<div className="top-twenty">
							<img src={zoomedImage} alt="zoomed capture" style={{ maxWidth: '100%' }} />
						</div>
					</div>
				</Dialog>
				<div className="top-twenty">
					<button
						className={"btn " + ((capturedImages.length && !generatingPdf) ? "btn-jt-primary" : "disabled-btn")}
						disabled={!capturedImages.length || generatingPdf}
						onClick={this.generatePdfFromImages}
					>
						{generatingPdf ? 'Generating PDF...' : 'Generate PDF'}
					</button>
				</div>
			</div>
		);
	}

    showEnterInvoiceDetails = () => {
        const { selectedInvoiceType, vendorInvoiceNo, invoiceDate, noOfUniqueItems, invoiceAmount, uploadResponse, docCreated, fileType, generatedPdfBlob, generatedPdfPreview } = this.state;
        const selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
        const isPilotFacility = selectedFacility && selectedFacility.facilityName && ['yard', 'sutlej/gomati', 'fc-chennai', 'fc-bhubaneswar', 'fc-lucknow', 'fc-ranchi'].includes(selectedFacility.facilityName.toLowerCase());
        return (
            <div>
                <div className="v-imp-txt">Invoice Details</div>
                <div className="top-twenty">
                    {(docCreated) ?
                        <div>
                            <div className="c-b-u">Document Type</div>
                            <div className="pod-itm-big">{selectedInvoiceType}</div>
                        </div>
                        :
                        <ExpDropSelector 
							options={invoiceTypes} 
							selected={selectedInvoiceType} 
							classes={{ drop: 'invoice-type-drop' }} 
							selctionChange={this.invoiceTypeSelected} 
							type={'Invoice Type'} 
						/>
                    }
                </div>
                
                <div className="top-twenty">
                    {(docCreated) ?
                        <div>
                            <div className="c-b-u">Vendor Invoice Number</div>
                            <div className="pod-itm-big">{vendorInvoiceNo}</div>
                        </div>
                        :
                        <InputFloating 
							type="text" 
							label="Vendor Invoice Number" 
							name="vendorInvoiceNo" 
							value={vendorInvoiceNo} 
							onChange={this.invoiceDetailChanged} 
						/>
                    }
                </div>
                <div className="top-twenty">
                    {(docCreated) ?
                        <div>
                            <div className="c-b-u">Vendor Invoice Date</div>
                            <div className="pod-itm-big">{invoiceDate}</div>
                        </div>
                        :
                        <div>
                            <InputFloating 
								type="date" 
								label="Vendor Invoice Date" 
								name="invoiceDate" 
								value={invoiceDate} 
								onChange={this.invoiceDetailChanged} 
							/>
                            	{(this.invoiceDateValidation()) ?
                                	<div className="error-text top-ten">
										{INVOICE_DATE_ERROR}
									</div> : null
                            	}
                        </div>
                    }

                </div>
				<div className="top-twenty">
                    <div className="c-b-u">Upload Invoice</div>
                    <div className="top-twenty">
                        {(uploadResponse) ?
                            <div>
                                {(fileType === "application/pdf") ?
                                    <div>
										{(docCreated) ?
											<LocalPDFViewer
												filePath={this.state.pdfFile}
											/> 
											: 
											<LocalPDFViewer
												filePath={this.state.pdfFile}
												onDeleteClick={this.onDeleteClick}
											/>
										}
                                    </div>
                                    :
                                    <div>
                                        {(docCreated) ?
                                            <ImageViewer src={uploadResponse} alt='Img' />
                                            :
                                            <ImageViewer src={uploadResponse} shouldRemove={true} onRemove={this.onDeleteClick} alt='Img' />
                                        }
                                    </div>

                                }
                            </div>
                            : (generatedPdfBlob) ?
                            <div>
								<LocalPDFViewer
									filePath={generatedPdfPreview}
									onDeleteClick={this.discardGeneratedPdf}
								/>
								<div className="top-twenty">
									<button className="btn btn-jt-primary" onClick={this.confirmGeneratedPdf}>
										Upload PDF
									</button>
								</div>
                            </div>
                            :
                            <div>
								{(isPilotFacility) &&
									<React.Fragment>
										{this.showCaptureImages()}
										<div className="top-twenty centralized" style={{ color: '#9a9f9a' }}>OR</div>
									</React.Fragment>
								}
								<div className="top-twenty">
									<GenericFileUploader
										noMessage="true"
										handleFileDrop={this.handleFileDrop}
										accept='.pdf'
										onDeleteClick={this.handleOnFileDelete}
										fileSizeLimit={CONF.FILE_SIZE_LIMIT_FOR_PDF_IN_BYTES}
									/>
								</div>
                            </div>
                        }
                    </div>
                </div>
                <div className="top-twenty">
                    {(docCreated) ?
                        <div>
                            <div className="c-b-u">No. of Unique Items</div>
                            <div className="pod-itm-big">{noOfUniqueItems}</div>
                        </div>
                        :
                        <InputFloating type="text" label="No. of Unique Items" name="noOfUniqueItems" value={noOfUniqueItems} onChange={this.invoiceDetailChanged} />
                    }
                </div>
                <div className="top-twenty">
                    {(docCreated) ?
                        <div>
                            <div className="c-b-u">Invoice Amount</div>
                            <div className="pod-itm-big">{numfor.format(invoiceAmount)}</div>
                        </div>
                        :
                        <div className="input-group">
                            <span className="input-group-addon">₹</span>
                            <InputFloating type="number" label="Invoice Amount" name="invoiceAmount" value={invoiceAmount} onChange={this.invoiceDetailChanged} />
                        </div>
                    }
                </div>
            </div>
        )
    }

    render() {
        const { docCreatedBox, docCreated } = this.state;
		const createBtnClass = `btn ${this.canDocumentCreationHappen() ? 'btn-big-blue' : 'btn-big-norm'}`;
        return (
            <div>
                <div style={{ padding: '10px', marginBottom: '80px' }}>
                    <div className="invoice-inward-wrapper">
                        <div className="v-imp-txt">Purchase Order Document (POD) Details</div>
                        <div>{this.showScannedPods()}</div>
                        <div>{this.showNewPOD()}</div>
                        <div className="pod-seperator"></div>
                        <div>{this.showEnterInvoiceDetails()}</div>
                    </div>
                </div>
                <div className="btm-actn-br">
                    {(docCreated) ?
                        <div className="row">
                            <div className="col-xs-6">
								<button 
									className="btn btn-big-norm" 
									onClick={this.goBackPage}
								>
									Back
								</button>
							</div>
                            <div className="col-xs-6">
								<button className="btn btn-big-green" onClick={this.startInwarding}>
									Proceed To Inward
								</button>
							</div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-8">
								<button 
									className={createBtnClass} 
									disabled={this.canDocumentCreationHappen() ? false : true} 
									onClick={this.createInwardingDocument}
								>
									Create Inwarding Document
								</button>
							</div>
                            <div className="col-xs-2"></div>
                        </div>
                    }
                </div>
                <Dialog open={docCreatedBox} maxWidth="lg" fullWidth={true} onClose={this.closeDocCreatedBox}>
                    <div className='po-dialog-container'>
                        <div className="text-right" onClick={this.closeDocCreatedBox}>
							<img src={close} className='cross-image' alt="x" />
						</div>
                        <div className="top-twenty">
							<img src={doc_done} alt="success-img" className='success-image' />
						</div>
                        <div className="top-thirty">Document Created Successfully</div>
                        <div className="top-thirty"></div>
                    </div>
                </Dialog>
                {(this.state.error) ?
                    <ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/InvoiceInwardTest.js